import React, { createContext, useState } from "react";
import { GlobalVariables } from "../../../global";

const CustomerContext = createContext();

const CustomerContextProvider = ({ children }) => {
  //Customer
  const [customerExists, setCustomerExists] = useState(false);
  const [documentType, setDocumentType] = useState("cnpj");
  const [reason, setReason] = useState("");
  const [fantasy, setFantasy] = useState("");
  const [cep, setCep] = useState("");
  const [uf, setUf] = useState("");
  const [county, setCounty] = useState("");
  const [address, setAddress] = useState("");
  const [number, setNumber] = useState("");
  const [district, setDistrict] = useState("");
  const [telephone, setTelephone] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [cnpjMatriz, setCnpjMatriz] = useState("");
  const [ie, setIe] = useState("");
  const [im, setIm] = useState("");
  const [complement, setComplement] = useState("");
  const [codIbge, setCodIbge] = useState("");
  const [email, setEmail] = useState("");
  const [listSegments, setListSegments] = useState([]);
  const [segment, setSegment] = useState(listSegments?.find((s) => s.Id === GlobalVariables.SEGMENTS.DEFAULT));
  const [checkMatriz, setCheckMatriz] = useState(false);
  const [checkAccountant, setCheckAccountant] = useState(false);
  const [listAccountants, setListAccountants] = useState([]);
  const [accountantCustomer, setAccountantCustomer] = useState(null);
  const [hasCertificate, setHasCertificate] = useState(false);
  const [passwordCertificate, setPasswordCertificate] = useState("");
  const [logomarca, setLogomarca] = useState("");
  const [birthDate, setBirthDate] = useState("");

  //Promocode
  const [listSellers, setListSellers] = useState([]);
  const [promocode, setPromocode] = useState({});
  const [consultantCompany, setConsultantCompany] = useState(null);
  const [consultantUser, setConsultantUser] = useState(null);
  const [franchisedCompany, setFranchisedCompany] = useState(null);
  const [franchisedUser, setFranchisedUser] = useState(null);
  const [accountantCompany, setAccountantCompany] = useState(null);
  const [accountantUser, setAccountantUser] = useState(null);
  const [entityCompany, setEntityCompany] = useState(null);
  const [entityUser, setEntityUser] = useState(null);

  //Products
  const [products, setProducts] = useState([
    {
      Id: 0,
      IdFamilia: 0,
      IdProduto: 0,
      IdVersao: 0,
      Rota: "",
      IdTipoPromotor: 0,
      PromotorCNPJ: "",
      IdUsuario: 0,
      DataExpiracao: "",
      DataContrato: "",
      DataCancelamento: "",
      DataBloqueio: "",
      DataConsultaLimite: "",
      Demo: false,
      Trial: false,
      Freemium: false,
      ValoresParametros: {},
      IdMotivoCancelamento: 0,
      Volumetrias: [],
    },
  ]);
  const [optionsFamily, setOptionsFamily] = useState([]);
  const [optionsProducts, setOptionsProducts] = useState([]);
  const [optionsVersions, setOptionsVersions] = useState([]);
  const [optionsCancellation, setOptionsCancellation] = useState([]);
  const [listVolumetries, setListVolumetries] = useState([]);
  const [maps, setMaps] = useState([]);

  //General
  const [errors, setErrors] = useState({});
  const [loadings, setLoadings] = useState({});
  const [promoters, setPromoters] = useState([]);

  return (
    <CustomerContext.Provider
      value={{
        documentType,
        setDocumentType,
        customerExists,
        setCustomerExists,
        reason,
        setReason,
        fantasy,
        setFantasy,
        cep,
        setCep,
        uf,
        setUf,
        county,
        setCounty,
        address,
        setAddress,
        number,
        setNumber,
        district,
        setDistrict,
        telephone,
        setTelephone,
        cnpj,
        setCnpj,
        cnpjMatriz,
        setCnpjMatriz,
        ie,
        setIe,
        im,
        setIm,
        complement,
        setComplement,
        codIbge,
        setCodIbge,
        email,
        setEmail,
        segment,
        setSegment,
        listSegments,
        setListSegments,
        checkMatriz,
        setCheckMatriz,
        checkAccountant,
        setCheckAccountant,
        listAccountants,
        setListAccountants,
        accountantCustomer,
        setAccountantCustomer,
        hasCertificate,
        setHasCertificate,
        passwordCertificate,
        setPasswordCertificate,
        logomarca,
        setLogomarca,
        birthDate,
        setBirthDate,
        listSellers,
        setListSellers,
        promocode,
        setPromocode,
        consultantCompany,
        setConsultantCompany,
        consultantUser,
        setConsultantUser,
        franchisedCompany,
        setFranchisedCompany,
        franchisedUser,
        setFranchisedUser,
        accountantCompany,
        setAccountantCompany,
        accountantUser,
        setAccountantUser,
        entityCompany,
        setEntityCompany,
        entityUser,
        setEntityUser,
        products,
        setProducts,
        optionsFamily,
        setOptionsFamily,
        optionsProducts,
        setOptionsProducts,
        optionsVersions,
        setOptionsVersions,
        optionsCancellation,
        setOptionsCancellation,
        listVolumetries,
        setListVolumetries,
        maps,
        setMaps,
        errors,
        setErrors,
        loadings,
        setLoadings,
        promoters,
        setPromoters,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export { CustomerContextProvider, CustomerContext };
